<template>
  <div class="login-card__register-phone-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.register.phone.header') }}</h1>
      <p class="login-card__title-desc" v-html="trans.get('auth.card.registration_agreement', {link1: '/abgn', link2: '/privacy'})"></p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-auto">
              <label for="phone-prefix"></label>
              <div class="selectdiv selectdiv--underline">
                <select id="phone-prefix" class="form-control" v-model="phone.prefix.selected">
                  <option v-for="option in phone.prefix.options" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col">
              <validation-provider name="phone" rules="required|min:9|max:12|numeric" v-slot="{ errors }" mode="eager">
                <label for="phone-number"></label>
                <input
                  id="phone-number" class="input-text__underline" v-model="phone.number"
                  placeholder="e.g. 793369165"
                >
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-group">
            <validation-provider name="password" rules="required" v-slot="{ errors }" mode="eager">
              <div class="input-group is-invalid">
                <label for="password"></label>
                <input
                  :type="passwordInputType" id="password" class="form-control input-text input-text__underline" v-model="form.password"
                  :placeholder="trans.get('auth.card.fields.password')"
                >
                <div class="input-group-append">
                  <button type="button" class="button__password-eye" @click="switchPasswordVisibility"><i
                    class="fa fa-eye" aria-hidden="true"
                  ></i></button>
                </div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <button
            type="submit"
            class="button button__fill button--w-100 mt-3"
          >{{ trans.get('auth.card.buttons.continue') }}
          </button>
        </form>
      </validation-observer>


      <button
        type="button" class="button button__link button__link--underline mt-3"
        @click="swapComponent('auth-welcome-card')"
      >{{ trans.get('auth.card.buttons.back') }}
      </button>
    </div>

    <p class="login-card__btn-desc">{{ trans.get('auth.card.registration_footer') }}</p>

  </div>
</template>
<script>

export default {
  props: ['swapComponent'],
  data: () => ({
    form: {
      phone: '',
      password: '',
    },
    phone: {
      prefix: {
        selected: null,
        options: []
      },
      number: null
    },
    passwordInputType: 'password',
  }),
  watch: {
    phone: {
      handler(phone) {
        this.form.phone = phone.prefix.selected + phone.number;
      },
      deep: true
    }
  },
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      const self = this;
      axios
        .post(zRoute('register'), {
          phone: this.form.phone,
          password: this.form.password,
          cid: window.localStorage.getItem('campaign_cid'),
          eid: window.localStorage.getItem('campaign_eid'),
          campaign_query: window.localStorage.getItem('campaign_query'),
        })
        .then(function (response) {
          if (response.data.status === 'success') {
            // if (window.globals.settings_verification_required) {
            if (response.data.verification_is_required) {
              self.swapComponent('auth-verification-phone-card');
            } else {
              self.swapComponent('auth-name-card');
            }
          }
        }, function (error) {
          if (error.response.status === 422) {
            if (!('phone' in error.response.data.errors || 'password' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'phone': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
  },
  mounted() {
    for (const [value, text] of Object.entries(window.globals.user.phone_prefixes)) {
      this.phone.prefix.options.push({
        text: text,
        value: value
      });
    }
    this.phone.prefix.selected = this.phone.prefix.options[0].value;
  },
};
</script>
<style scoped>
</style>
